/**
 * External dependencies
 */
import React from 'react';
// import { SHIPPING_COUNTRIES } from '@woocommerce/block-settings';
import { SHIPPING_COUNTRIES } from '../../../settings/blocks';
/**
 * Internal dependencies
 */
import CountryInput from './country-input';
import { CountryInputProps } from './CountryInputProps';

const ShippingCountryInput = ( props: CountryInputProps ): JSX.Element => {
	return <CountryInput countries={ SHIPPING_COUNTRIES } { ...props } />;
};

export default ShippingCountryInput;
